import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import {HeroReport} from "./hero-report.model";
import {HeroReportService} from "./hero-report.service";

export const heroReportResolver: ResolveFn<HeroReport[]> = (route, state) => {
  const heroReportService: HeroReportService = inject(HeroReportService)
  return heroReportService.fetch()
};
